module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"cloudStorage":"云空间","moreStorage":"开通VIP 获取云空间"},"en":{"cloudStorage":"Used Space","moreStorage":"Upgrade for More Space"},"fr":{"cloudStorage":"Espace utilisé","moreStorage":"Plus d\u0027espace"},"de":{"cloudStorage":"Belegter Speicher","moreStorage":"Mehr Platz"},"jp":{"cloudStorage":"使用済み領域","moreStorage":"領域を追加する"},"es":{},"pt":{},"it":{},"tw":{},"kr":{}}')
  delete Component.options._Ctor
}
